<template>
    <div :class="$style.backdrop">
        <div :class="$style.content">
            <CircularLoader :class="$style.loader" />

            <h1 :class="$style.title">{{ $t("headlines.create_ticket") }}</h1>

            <h2 :class="$style.ship">{{ $t("headlines.close_tab_and_send_to_email_and_sms") }}</h2>
        </div>
    </div>
</template>

<script>
import CircularLoader from "./CircularLoader";

export default {
    name: "ModalCheckingTicket",
    components: { CircularLoader },
    beforeMount() {
        document.body.style.overflowY = "hidden";
    },
    beforeDestroy() {
        document.body.style.overflowY = "auto";
    },
};
</script>

<style module lang="postcss">
.backdrop {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background-color: rgba(255, 255, 255, 1);
    display: flex;
    align-items: center;
    justify-content: center;
}

.content {
    display: flex;
    flex-direction: column;
}

.title {
    font-size: 18px;
    font-weight: 200;
    margin: 24px 0 0 0;
    color: #000;
    text-align: center;
}

.ship {
    font-size: 14px;
    font-weight: 200;
    margin: 16px 0 0 0;
    color: #000;
    text-align: center;
}
</style>
